import { render } from "@/components/pages/individualWorkSupport/requirement148/Requirement148.html?vue&type=template&id=0a994ba6&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement148/Requirement148.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement148/Requirement148.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement148/Requirement148.scss?vue&type=style&index=0&id=0a994ba6&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a994ba6"]])

export default __exports__